var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23.762,
    viewBox: "0 0 24 23.762",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.464 -3.702)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M238.526,10.644h.841a11.129,11.129,0,0,0-7.787-5.867.589.589,0,0,1-.089.248l-.257.445-2.988,5.175h10.28Zm0,0",
    transform: "translate(-215.563 -1.076)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.1,127.4H8.145l-2.039-3.552-3.651-6.314-.471-.8A12.328,12.328,0,0,0,0,123.443a12.185,12.185,0,0,0,.691,4.066A.863.863,0,0,1,1.1,127.4Zm0,0",
    transform: "translate(1.464 -108.064)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M28.859,372.267h-.871a11.633,11.633,0,0,0,8.114,6.479.841.841,0,0,1,.1-.4l.2-.371h.011l3.084-5.705H28.859Zm0,0",
    transform: "translate(-25.405 -351.508)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M62.865,5.012l3.349,5.8,2.018-3.493.078-.144L71.969.832l.466-.82C72.224,0,72,0,71.791,0a12.378,12.378,0,0,0-9.436,4.336,1.056,1.056,0,0,1,.288.3Zm0,0",
    transform: "translate(-57.786 3.703)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M252.884,296.54a.694.694,0,0,1-.306-.294l-.226-.386-3.422-5.938-2.062,3.582-.1.192-3.719,6.437-.488.838c.227,0,.443.012.669.012A12.687,12.687,0,0,0,252.884,296.54Zm0,0",
    transform: "translate(-230.514 -273.519)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M350.2,171.7H342.91l2.108,3.672,3.774,6.528.488.828a12.746,12.746,0,0,0,2.052-6.936,12.6,12.6,0,0,0-.714-4.2A.892.892,0,0,1,350.2,171.7Zm0,0",
    transform: "translate(-325.868 -160.469)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.0f5fd6b3f02d743a1a65266c39e73258.svg";
export { ForwardRef as ReactComponent };